import { Link } from 'react-router-dom';
import { ModuleLanding, ModuleOffers, Faq, SectionHead, Rating } from '../../shared/components/Common';
import { SmartImg } from '../../shared/components/Layout';
import Icon from '../../shared/components/Icons';
import { destinations, formatPrice, img } from '../../shared/data/common';
import { usePackages } from './PackagesContext';

const themeIcons = { Honeymoon: 'packages', Family: 'user', Friends: 'sightseeing', Culture: 'compass', Adventure: 'zap' };

const faqs = [
  ['What is included in a holiday package?', 'Most packages include hotel stay, daily breakfast, transfers and sightseeing. International packages usually include flights and visa as listed under inclusions.'],
  ['Can I customise my itinerary?', 'Yes. After booking, our holiday experts will call you to personalise hotels, activities and dates.'],
  ['What is TCS on international packages?', 'As per Indian tax rules, 5% Tax Collected at Source applies to overseas tour packages. You can claim it back while filing your income tax return.'],
  ['What is the cancellation policy?', 'More than 30 days before departure: 10% charge. 15–30 days: 50%. Less than 15 days: non-refundable.'],
];

export default function PackageSearch() {
  const { packages, themes } = usePackages();
  return (
    <ModuleLanding tab="packages" title="Holiday packages" subtitle="Handcrafted itineraries with flights, stays, transfers & sightseeing — save up to 25%" image={img('1507525428034-b723cf961d3e', 1800)}>
      <section className="section container">
        <SectionHead title="Holidays by theme" />
        <div className="theme-tiles">
          {themes.filter((t) => t !== 'All').map((t) => (
            <Link key={t} to={`/packages/results?theme=${t}`} className="theme-tile">
              <span className="perk-icon"><Icon name={themeIcons[t] || 'packages'} size={22} /></span>
              <b>{t}</b><span className="muted small">{packages.filter((p) => p.theme === t).length} packages</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Holiday offers" />
        <ModuleOffers module="packages" />
      </section>

      <section className="section container">
        <SectionHead title="Trending destinations" link={{ to: '/packages/results', label: 'All packages' }} />
        <div className="dest-grid">
          {destinations.map((d) => (
            <Link key={d.name} to={`/packages/results?destination=${d.name}`} className="dest-card">
              <SmartImg src={d.image} alt={d.name} />
              <div className="dest-info">
                <span className="dest-country">{d.country}</span>
                <h3>{d.name}</h3>
                <span className="dest-price">Holidays from <b>{formatPrice(d.from)}</b></span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Best sellers" />
        <div className="card-grid">
          {[...packages].sort((a, b) => (b.reviews || 0) - (a.reviews || 0)).slice(0, 4).map((p) => (
            <Link key={p.id} to={`/packages/${p.id}`} className="card hover">
              <div className="card-img"><SmartImg src={p.image} alt={p.title} /><span className="badge badge-dark">{p.nights}N / {p.nights + 1}D</span></div>
              <div className="card-body">
                <span className="muted small"><Icon name="pin" size={12} /> {p.cities.join(' · ')}</span>
                <h3>{p.title}</h3>
                <div className="price-row"><div><b className="price">{formatPrice(p.price)}</b><span className="muted small"> /person</span></div><Rating value={p.rating} compact /></div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Frequently asked questions" />
        <Faq items={faqs} />
      </section>
    </ModuleLanding>
  );
}
